import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { CompanyDetails } from "../../data/component/models-interfaces/manage-company/company-interface";
@Injectable({
  providedIn: "root",
})
export class CustomerTypeService {
  constructor(private httpClient: HttpClient) {}

  getAllCustomerTypeList(page: any, limit: any, search?: any) {
    const apiUrl = `${environment.serverEndPoint}/customer/list?page=${page}&limit=${limit}&name=${search}`;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getCustomerType(id: any) {
    const apiUrl = `${environment.serverEndPoint}/customer/` + id;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  createCustomerType(data: any) {
    const apiUrl = `${environment.serverEndPoint}/customer/create`;
    return this.httpClient.post<CompanyDetails>(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  updateCustomerType(id: any, data: any) {
    const apiUrl = `${environment.serverEndPoint}/customer/update/` + id;
    return this.httpClient.put(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
  
  deleteCustomerType(id: any, data: boolean) {
    const sendData = { isDeleted: data };
    const apiUrl = `${environment.serverEndPoint}/customer/status-update/` + id;
    return this.httpClient.put(apiUrl, sendData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getDropdownCustomerType() {
    const apiUrl = `${environment.serverEndPoint}/customer/dropdown/list`;
    return this.httpClient.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
      }
    });
  }
}
